import { SidebarModal } from '@domain-group/suit-theme'

import type { UseOrderItemTaskAttachmentsPayload } from '@hooks/useOrderItemTaskAttachments'

import { formatEntityCount } from '@functions/entity'

import ImageGrid from '../ImageGrid'

interface AttachmentsProps {
  orderItemTaskAttachmentsPayload: UseOrderItemTaskAttachmentsPayload,
}

const Attachments = (props: AttachmentsProps) => {
  const {
    orderItemTaskAttachmentsPayload: { filteredOrderItemTaskAttachments, filteredOrderItemTaskAttachmentsCount },
  } = props

  const attachmentsText = formatEntityCount({
    entityCount: filteredOrderItemTaskAttachmentsCount,
    entityString: 'Attachment',
  })

  return (
    <SidebarModal.ExpandableSectionBox
      boxProps={{ backgroundColor: 'white', marginTop: 'large' }}
      headerBoxProps={{ paddingX: 0, paddingTop: 0 }}
      contentBoxProps={{ paddingX: 0 }}
      label={attachmentsText}
    >
      <ImageGrid
        downloadPath="size.original"
        entityArray={filteredOrderItemTaskAttachments}
        urlPath="size.thumb"
      />
    </SidebarModal.ExpandableSectionBox>
  )
}

export default Attachments
